import _ from 'lodash'
import { STORE_PARTY_ID, CLEAN_PARTY_ID } from '../../constants/actionTypes'

const initialState = {
  partyId: null,
}

const auditPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_PARTY_ID:
      return Object.assign({}, state, {
        partyId: _.get(action.user, 'person.party_id', null),
      })
    case CLEAN_PARTY_ID:
      return Object.assign({}, initialState)
    default:
      return state
  }
}

export default auditPageReducer
